(() => {
    class CustomProgressVideo extends HTMLElement {
        constructor() {
            super();
            this.videoElement = this.querySelector('video');
            this.progressBar = this.querySelector('input[type="range"]');
            if(!this.videoElement && !this.progressBar) return;

            const self = this;
            this.videoElement.addEventListener("timeupdate", () => {
                const duration = Math.round(self.videoElement.duration);
                const currentTime = Math.round(self.videoElement.currentTime);
                self.progressBar.setAttribute('max',duration);
                self.progressBar.value = currentTime;
                self.progressBar.setAttribute('value',currentTime);
            })

            this.progressBar.addEventListener('input', (event) => {
                const rewindTime = event.target.value;
                self.progressBar.value = rewindTime;
                self.videoElement.currentTime = parseInt(rewindTime);
                self.videoElement.play();
            });
        }
    }
    customElements.define('custom-progress-video', CustomProgressVideo);
})()